module.exports = __webpack_public_path__ + "static/uptrend-logo-1617f4f5db7c8d5c8238bb43c7e96716.svg";